// components/TopNavbar.jsx
import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import './TopNavbar.css';

const TopNavbar = () => {
  return (
    <div className="top-navbar">
      {/* Left Section - Contact Info */}
      <div className="left-section">
        <span><FaPhoneAlt /> +91 9078979508</span>
        <span><FaEnvelope /> hello@SuperXTech.io</span>
      </div>

      {/* Right Section - Social Links */}
      <div className="right-section">
        <a href="https://www.facebook.com/SuperXTech" target="_blank" rel="noopener noreferrer">
          <FaFacebookF />
        </a>
        <a href="https://www.linkedin.com/company/superxtech-solutions?trk=public_profile_topcard-current-company" target="_blank" rel="noopener noreferrer">
          <FaLinkedinIn />
        </a>
        {/* <a href="https://instagram.com/SuperXTech" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a> */}
      </div>
    </div>
  );
};

export default TopNavbar;
